module.exports = __webpack_public_path__ + "static/media/packaging-banner.54bb467a.webp";